// TOOL-481: silent auth expiration leaves the UI looking interactive while
// API calls 401 in the background. This gates the redirect so it fires once
// per app load, never on public routes (login page), to avoid redirect loops.
export const shouldHandleSessionExpiry = ({
  status,
  isPublicRoute,
  alreadyHandled,
}: {
  status: number
  isPublicRoute: boolean
  alreadyHandled: boolean
}): boolean => status === 401 && !isPublicRoute && !alreadyHandled
